import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ParkinsonismPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Parkinsonism</h1>
        <section className="mb-8">
          <p>Parkinsonism is a neurological condition characterized by movement disorders and other symptoms. Our natural therapies focus on improving motor function, reducing symptoms, and supporting overall neurological health through gentle, effective herbal remedies and holistic approaches.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Neurological degeneration</li>
            <li>Environmental factors</li>
            <li>Genetic predisposition</li>
            <li>Oxidative stress</li>
            <li>Age-related changes</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Tremors</li>
            <li>Muscle stiffness</li>
            <li>Balance problems</li>
            <li>Slow movements</li>
            <li>Speech difficulties</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use neuroprotective herbs, movement-enhancing agents, and lifestyle modifications to naturally support Parkinsonism patients. Our approach focuses on improving motor function, reducing symptoms, and promoting neurological health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Improved motor function</li>
            <li>Reduced symptoms</li>
            <li>No harsh side effects</li>
            <li>Better quality of life</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Regular exercise</li>
            <li>Balanced diet</li>
            <li>Stress management</li>
            <li>Physical therapy</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Results vary by individual, but many patients notice improvement within 3-4 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of Parkinsonism.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment be used alongside conventional medication?</strong>
            <p>A: Yes, our treatments can complement conventional medication, but please consult with your healthcare provider.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Improve your quality of life—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ParkinsonismPage; 